import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import ConsultExperience from "./WorkExperience/ConsultExperience";
import EditExperience from "./WorkExperience/EditExperience";
import classes from "./ProfessionalExperiences.module.css";
import Icon from "../../../UI/Icon/Icon";
import NewExperienceEntity from "../../../../Entities/NewExperienceEntity";
import {cloneDeep} from "lodash";
import Aux from "../../../../hoc/Auxiliary/Auxiliary";
import {translation} from "../../../../I18n/i18n";

const ProfessionalExperiences = (props) => {

    const [newExperiences, setNewExperiences] = useState ([]);
    const [isOnAdding, setIsOnAdding] = useState (false);
    const [onEditIndex] = useState (Array (props.element.length).fill (false));

    const [refresher, setRefresher] = useState (true);

    useEffect (() => props.setIsOnEditingExpr (false), [])

    let getLabelByExperience = (e) => {
        return `${ e.Employer.Name._text } - ${ e.Position.Label._text }`;
    }

    /**
     * Put the selected experience in edit mode, if there are no changes to save.
     */
    let onEditClickHandler = (e, i) => {
        if (props.isOnEditingExpr && props.hasChanges) {
            props.launchUnsavedExprPopup (e)
        } else {
            onEditIndex.fill (false);
            onEditIndex[i] = true;
            setIsOnAdding(false);
            props.setIsOnEditingExpr (true);
            setRefresher (!refresher)
        }
    };

    let onDeleteClickHandler = (i) => {
        props.element.splice (i, 1);
        onEditIndex.splice (i, 1);
        setRefresher (!refresher)
    }

    let consultForm = (e, index) => {
        return <ConsultExperience
            lang={props.lang}
            key={ index }
            index={ index }
            experience={ e }
            title={ getLabelByExperience (e) }
            hasWriteAccess={ props.hasWriteAccess }
            onEditClick={ (i) => onEditClickHandler (e, i) }
            onDeleteClick={ (i) => onDeleteClickHandler (i) }/>
    }

    let refreshEditingHandler = (editedExperience, i) => {
        onEditIndex[i] = false;
        props.setIsOnEditingExpr (false);
        props.setEditingExperience ({index: -1, experience: cloneDeep (NewExperienceEntity)});
        setRefresher (!refresher)
        props.sortExperiences ();
    };

    let editForm = (e, i) => {
        return <EditExperience
            dict={props.dict}
            addToDictionary={ props.addToDictionary }
            lang={props.lang}
            experience={ e }
            setUpdateExpr={ props.setUpdateExpr }
            editingExperience={ {index: i, experience: props.editingExperience.experience} }
            setEditingExperience={ props.setEditingExperience }
            setIsAnyEmptyExprField={props.setIsAnyEmptyExprField}
            title={ ` Edit ${ getLabelByExperience (e) }` }
            refresh={ () => refreshEditingHandler (e, i) }/>
    }

    let refreshAddingHandler = () => {
        if (props.element) {
            setIsOnAdding (false);
            props.setIsOnEditingExpr (false);
            props.setEditingExperience ({index: -1, experience: cloneDeep (NewExperienceEntity)});
            setRefresher (!refresher)
            props.sortExperiences ();
        }
    };

    let addForm = (e) => {
        return <EditExperience
            dict={props.dict}
            addToDictionary={ props.addToDictionary }
            lang={props.lang}
            experience={ e }
            title={translation(props.lang, "New Professional experience" )}
            setUpdateExpr={ props.setUpdateExpr }
            editingExperience={ {index: -1, experience: props.editingExperience.experience} }
            setEditingExperience={ props.setEditingExperience }
            setIsAnyEmptyExprField={props.setIsAnyEmptyExprField}
            refresh={ () => refreshAddingHandler () }/>
    }

    let onAddClickHandler = (e) => {
        if (props.isOnEditingExpr && props.hasChanges) {
            props.launchUnsavedExprPopup (e)
        } else {
            onEditIndex.fill (false);
            setIsOnAdding (true);
            props.setIsOnEditingExpr (true);
            setRefresher (!refresher)
            setNewExperiences (newExperiences.concat (cloneDeep (NewExperienceEntity)));
        }
    };

    return (
        <Aux>
            { props.element.map ((e, i) => {
                let clonedExperience = cloneDeep (props.element[i]);
                return (
                    <div key={i} className={ classes.experience }>
                        { !onEditIndex[i] ? consultForm (e, i) : editForm (clonedExperience, i) }
                    </div>
                );
            }) }
            { isOnAdding ?
                addForm (newExperiences[newExperiences.length - 1])
                :
                props.hasWriteAccess && <Row className={ classes.SpacingTop }>
                    <Col sm="11"/>
                    <Col sm="1">
                        <Icon
                            classIcon="fas fa-plus-circle"
                            color="#464775"
                            size="30"
                            label="Add new Experience"
                            action={ onAddClickHandler }
                        />
                    </Col>
                </Row> }
        </Aux>
    );
};

export default ProfessionalExperiences;